module.exports = __webpack_public_path__ + "static/media/SeeSignage_background.a6370ee2.jpg";